module.exports = __webpack_public_path__ + "static/media/plan_pk_1.4c2043f1.doc";